import { createFileRoute } from '@tanstack/react-router'

import { PageLayout } from '@/components/layout'

import { CategoryForm } from '@/features/product/components/product-category-form'

export const Route = createFileRoute('/_app/product/category/create')({
  loader: () => ({
    crumb: 'Tambah Kategori',
  }),
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  return (
    <PageLayout>
      <CategoryForm
        mode='create'
        onBack={() => navigate({ to: '/product/category', replace: true })}
      />
    </PageLayout>
  )
}
